import { FC } from 'react';

import Dragger from 'antd/es/upload/Dragger';
import { UploadProps } from 'antd';
import { InboxOutlined } from '@ant-design/icons';

interface DraggerUploadFileProps {
  draggerProps: UploadProps;
  fileList?: any[];
  onPreview?: (file: any) => void;
  formatFile?: string;
  className?: string;
  multiple?: boolean
}

export const DraggerUploadFile: FC<DraggerUploadFileProps> = ({ draggerProps, fileList, onPreview, formatFile, className, multiple }) => {
  return (
    <Dragger
      {...draggerProps}
      {...(fileList && {fileList: fileList})}
      onPreview={(file) => onPreview?.(file)}
      className={className}
      multiple={multiple}
    >
      <p className='ant-upload-drag-icon'>
        <InboxOutlined />
      </p>

      <p className='ant-upload-text'>
        Haga clic o arrastre el archivo a esta área para cargarlo.
      </p>

      {formatFile && (
        <p className='ant-upload-hint'>
          El archivo debe ser formato {formatFile}
        </p>
      )}
    </Dragger>
  );
};
